export function elementToString(element) {
  if (!element) {
    return '<null>';
  }

  var id = element.id ? " id=\"".concat(element.id, "\"") : '';
  return "<".concat(element.$type).concat(id, " />");
}
//# sourceMappingURL=Util.js.map